export enum LogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  FATAL = 'fatal',
}

export type LogEntryData = {
  message: string
  level: LogLevel
  data: any
}

export type LogEntryResponse = { ok: boolean }
